import { render, staticRenderFns } from "./CompanyShow.vue?vue&type=template&id=4c01fc22&scoped=true"
import script from "./CompanyShow.vue?vue&type=script&lang=js"
export * from "./CompanyShow.vue?vue&type=script&lang=js"
import style0 from "./CompanyShow.vue?vue&type=style&index=0&id=4c01fc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c01fc22",
  null
  
)

export default component.exports